import Service from './Service'
import { EVENT } from './apiUrls'

export default class EventService extends Service {
  deleteMany (query) {
    return this.axios.delete(`${EVENT}`, {params: query})
  }
}



// WEBPACK FOOTER //
// ./src/services/api/EventService.js